<template>
  <div class="report-check">
    <div class="data-content">
      <div class="table-head">
        <div class="table-title">
          <span style="font-weight: bold;margin-left: 20px; margin-right: 20px;">用户分析</span>
          <DatePicker :clearable="false" v-model="SelectedDate" type="daterange" split-panels placeholder="输入开始和结束日期"
            style="width: 200px" @on-change="dateChange"></DatePicker>
          <Select @on-query-change="deviceTypeChanged" v-model="filterData.local_device_type" :clearable="false"
            style="width: 130px; margin-left: 20px; margin-right: 20px;">
            <Option v-for="item in filterData.localDeviceType" :value="item.value" :key="item.value">{{item.label }}
            </Option>
          </Select>
          <Button @click="getData()">搜索</Button>
        </div>
        <div>
        </div>
      </div>
      <div style="width: 100%; display: flex;">
        <div class="report-content">
          <Table stripe border highlight-row :columns="getCurrentColumns()" :data="changeDataList"
            @on-selection-change="selected" :height="tableHeight">
            <template slot-scope="{ row, index }" slot="date">
              <span>{{ row.date }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="category_name">
              <span>{{ row.category_name }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="new_user_count">
              <span>{{ row.new_user_count }}</span>
            </template>

            <template v-if="filterData.local_device_type == 0" slot-scope="{ row, index }" slot="income_rmb">
              <span>{{ row.income_rmb }}</span>
            </template>

            <template v-if="filterData.local_device_type == 0" slot-scope="{ row, index }" slot="active_user_count">
              <span>{{ row.active_user_count }}</span>
            </template>

            <template slot-scope="{ row, index }" slot="puc_d1">
              <span>{{ row.puc_d1 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="income_d1">
              <span>{{ row.income_d1 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="pay_rate1">
              <span>{{ row.pay_rate1 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="arpu1">
              <span>{{ row.arpu1 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="arppu1">
              <span>{{ row.arppu1 }}</span>
            </template>
            
            <template slot-scope="{ row, index }" slot="puc_d7">
              <span>{{ row.puc_d7 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="income_d7">
              <span>{{ row.income_d7 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="pay_rate7">
              <span>{{ row.pay_rate7 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="arpu7">
              <span>{{ row.arpu7 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="arppu7">
              <span>{{ row.arppu7 }}</span>
            </template>
            
            <template slot-scope="{ row, index }" slot="puc_d30">
              <span>{{ row.puc_d30 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="income_d30">
              <span>{{ row.income_d30 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="pay_rate30">
              <span>{{ row.pay_rate30 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="arpu30">
              <span>{{ row.arpu30 }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="arppu30">
              <span>{{ row.arppu30 }}</span>
            </template>
            
          </Table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apis from "../../http/api";

  export default {
    name: "AnalyseList",
    components: {},
    watch: {},
    data() {
      return {
        tableHeight: 400,
        SelectedDate: null,
        filterData: {
          keyword: null,
          local_device_type: 0,
          localDeviceType: [{
            'label': '安卓/苹果',
            'value': -1
          }, {
            'label': '安卓&苹果',
            'value': 0
          }, {
            'label': '苹果',
            'value': 1
          }, {
            'label': '安卓',
            'value': 2
          }],
        },
        dataList: [],
        columns: [{
            title: '统计日期',
            slot: 'date',
            align: 'center',
            fixed: 'left',
            width: 120,
            sortable: true
          },
          {
            title: '设备类型',
            slot: 'category_name',
            align: 'center',
            width: 120,
            filters: [{
                label: '苹果',
                value: 1
              },
              {
                label: '安卓',
                value: 2
              }
            ],
            filterMultiple: false,
            filterMethod(value, row) {
              if (value === 1) {
                return row.category_name === '苹果';
              } else if (value === 2) {
                return row.category_name === '安卓';
              }
            }
          },
          {
            title: '新注册人数',
            slot: 'new_user_count',
            align: 'center',
            width: 110
          },
          {
            title: '首日',
            align: 'center',
            children: [{
                title: '人数',
                slot: 'puc_d1',
                align: 'center',
                width: 90
              },
              {
                title: '金额',
                slot: 'income_d1',
                align: 'center',
                width: 90
              },
              {
                title: '付费率',
                slot: 'pay_rate1',
                align: 'center',
                width: 90
              },
              {
                title: 'arpu',
                slot: 'arpu1',
                align: 'center',
                width: 90
              },
              {
                title: 'arppu',
                slot: 'arppu1',
                align: 'center',
                width: 90
              }
            ]
          },
          {
            title: '7日',
            align: 'center',
            children: [{
                title: '人数',
                slot: 'puc_d7',
                align: 'center',
                width: 90
              },
              {
                title: '金额',
                slot: 'income_d7',
                align: 'center',
                width: 90
              },
              {
                title: '付费率',
                slot: 'pay_rate7',
                align: 'center',
                width: 90
              },
              {
                title: 'arpu',
                slot: 'arpu7',
                align: 'center',
                width: 90
              },
              {
                title: 'arppu',
                slot: 'arppu7',
                align: 'center',
                width: 90
              }
            ]
          },
          {
            title: '30日',
            align: 'center',
            children: [{
                title: '人数',
                slot: 'puc_d30',
                align: 'center',
                width: 90
              },
              {
                title: '金额',
                slot: 'income_d30',
                align: 'center',
                width: 90
              },
              {
                title: '付费率',
                slot: 'pay_rate30',
                align: 'center',
                width: 90
              },
              {
                title: 'arpu',
                slot: 'arpu30',
                align: 'center',
                width: 90
              },
              {
                title: 'arppu',
                slot: 'arppu30',
                align: 'center',
                width: 90
              }
            ]
          }
        ],
      }
    },
    created() {
      const end = new Date();
      const start = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 );
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (31 - 1));
      this.SelectedDate = [start, end];
      this.tableHeight = window.innerHeight - 180
      window.addEventListener('resize', this.handleResize);
      this.getData()
    },
    methods: {
      getCurrentColumns() {
        if (this.filterData.local_device_type == 0) {
          return [{
              title: '统计日期',
              slot: 'date',
              align: 'center',
              fixed: 'left',
              width: 120,
              sortable: true
            },
            {
              title: '设备类型',
              slot: 'category_name',
              align: 'center',
              width: 120,
              filters: [{
                  label: '苹果',
                  value: 1
                },
                {
                  label: '安卓',
                  value: 2
                }
              ],
              filterMultiple: false,
              filterMethod(value, row) {
                if (value === 1) {
                  return row.category_name === '苹果';
                } else if (value === 2) {
                  return row.category_name === '安卓';
                }
              }
            },
            {
              title: '新注册人数',
              slot: 'new_user_count',
              align: 'center',
              width: 110
            },
            {
              title: '当日总收入',
              slot: 'income_rmb',
              align: 'center',
              width: 110,
            },
            {
              title: '当日总活跃人数',
              slot: 'active_user_count',
              align: 'center',
              width: 140
            },
            {
              title: '首日',
              align: 'center',
              children: [{
                  title: '人数',
                  slot: 'puc_d1',
                  align: 'center',
                  width: 90
                },
                {
                  title: '金额',
                  slot: 'income_d1',
                  align: 'center',
                  width: 90
                },
                {
                  title: '付费率',
                  slot: 'pay_rate1',
                  align: 'center',
                  width: 90
                },
                {
                  title: 'arpu',
                  slot: 'arpu1',
                  align: 'center',
                  width: 90
                },
                {
                  title: 'arppu',
                  slot: 'arppu1',
                  align: 'center',
                  width: 90
                }
              ]
            },
            {
              title: '7日',
              align: 'center',
              children: [{
                  title: '人数',
                  slot: 'puc_d7',
                  align: 'center',
                  width: 90
                },
                {
                  title: '金额',
                  slot: 'income_d7',
                  align: 'center',
                  width: 90
                },
                {
                  title: '付费率',
                  slot: 'pay_rate7',
                  align: 'center',
                  width: 90
                },
                {
                  title: 'arpu',
                  slot: 'arpu7',
                  align: 'center',
                  width: 90
                },
                {
                  title: 'arppu',
                  slot: 'arppu7',
                  align: 'center',
                  width: 90
                }
              ]
            },
            {
              title: '30日',
              align: 'center',
              children: [{
                  title: '人数',
                  slot: 'puc_d30',
                  align: 'center',
                  width: 90
                },
                {
                  title: '金额',
                  slot: 'income_d30',
                  align: 'center',
                  width: 90
                },
                {
                  title: '付费率',
                  slot: 'pay_rate30',
                  align: 'center',
                  width: 90
                },
                {
                  title: 'arpu',
                  slot: 'arpu30',
                  align: 'center',
                  width: 90
                },
                {
                  title: 'arppu',
                  slot: 'arppu30',
                  align: 'center',
                  width: 90
                }
              ]
            }
          ]
        }
        return this.columns
      },
      handleResize() {
        this.tableHeight = window.innerHeight - 180
      },
      deviceTypeChanged(options) {
        this.getData()
      },
      getData() {
        let params = {
          start_date: this.$moment(this.SelectedDate[0]).format("YYYY-MM-DD"),
          end_date: this.$moment(this.SelectedDate[1]).format("YYYY-MM-DD"),
          category: this.filterData.local_device_type
        };
        apis.user_analyse_new_user_income_list(params).then(res => {
          const {
            data,
            errCode,
            msg
          } = res;
          if (errCode === 0) {
            this.dataList = data.incomes;
          } else {
            this.$Message.error(msg);
            this.dataList = null
          }
        }).catch(err => {
          this.$Message.error('接口异常,请联系管理员');
          this.dataList = []
        })
      },
      dateChange(data) {
        this.getData()
      },
      toResetUseInfo(key, row, content) {

      },
      selected(selecttion) {
        console.log(selecttion.id)
      },
    },
    computed: {
      changeDataList() {
        return this.dataList.map(item => {
          item['date'] = item['date'].replace(/\s.*$/, '');
          var categoryName = '[[安卓&苹果]]'
          switch (item.category) {
            case 2:
              categoryName = '安卓'
              break
            case 1:
              categoryName = '苹果'
              break
            default:
              categoryName = '[安卓&苹果]'
              break
          }
          item['category_name'] = categoryName
 
          return item
        })
      }
    },
    filters: {}
  }
</script>

<style scoped>
  .report-check {
    margin: 10px;
  }

  .clickable-span {
    color: #1890ff;
    text-decoration: underline;
    cursor: pointer;
  }

  .text-center {
    text-align: center;
  }

  .table-head {
    display: flex;
    justify-content: space-between;
    padding-bottom: 5px;
  }

  .table-title {
    align-self: center;
  }

  .modal1-div {
    margin-bottom: 10px;
  }

  .info-pop {
    white-space: pre-wrap;
  }

  .avatar {
    float: left;
    width: 50px;
    margin-top: 20px;
    margin-right: 15px;
  }

  .img-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid lightgray;
  }

  .img-avatar-preview {
    width: 400px;
    height: 400px;
  }

  .report-content {
    float: left;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
  }

  .report-table-td-title {
    width: 95px;
    color: #333333;
    /* font-size: 18px; */
    padding-left: 5px;
    padding-right: 5px;
    vertical-align: top;
  }

  .report-table-td-content {
    width: 360px;
    color: #333333;
    /* font-size: 18px; */
    padding-left: 5px;
    padding-right: 5px;
  }

  table,
  th,
  td {
    border: 2px solid transparent;
    border-collapse: collapse;
  }

  table,
  td {
    height: auto;
  }

  .report-button {
    font-size: 12px;
    margin-left: 5px;
    width: 100px;
    height: 22px;
    margin-right: 5px;
  }

  .report-button-other {
    font-size: 12px;
    margin-left: 5px;
    width: 100px;
    height: 22px;
    margin-right: 5px;
    background-color: #fff;
    /* border-color: #f90; */
    border: 0.5px solid #ff9900;
    color: #f90;
  }
</style>